module.exports = __webpack_public_path__ + "img/value-5.81796e34.png";